/**
 * Root Application Component
 * 
 * This is the main App component that sets up the Redux store provider
 * and initializes the application routing. It serves as the top-level
 * component that wraps the entire application.
 */

import { Provider } from 'react-redux';
import { store } from './store';
import AppRouter from './router/AppRouter.tsx';
import { ErrorProvider } from './context/ErrorContext';
import { RBACProvider } from './context/RBACContext';
// import EnvironmentInfo from './components/debug/EnvironmentInfo';
// import ApiConnectionStatus from './components/debug/ApiConnectionStatus';

/**
 * App Component
 * 
 * Provides Redux store context to all child components and initializes
 * the application router for handling navigation.
 * 
 * @returns JSX element containing the complete application structure
 */
function App() {
  return (
    // Redux Provider makes the store available to all components
    <Provider store={store}>
      {/* RBAC Provider for role-based access control */}
      <RBACProvider>
        {/* Error Provider handles error context for API retry functionality */}
        <ErrorProvider>
          {/* AppRouter handles all application routing and navigation */}
          <AppRouter />
        </ErrorProvider>
      </RBACProvider>
      
      {/* Development Debug Components - Only visible in development mode */}
      {/* <EnvironmentInfo />
      <ApiConnectionStatus /> */}
    </Provider>
  );
}

export default App;
